import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";

const STOP = { replied: "ha risposto", dnc: "non contattare", converted: "diventato cliente", lost: "perso", spam: "spam", no_consent: "senza consenso marketing",
  no_email: "senza email", completed: "sequenza finita", disabled: "automazione spenta" };

// Who is in the «No response» sequence, and where they are. Staff can mark a reply received outside connected channels.
export function FollowupList({ tid, canWrite, reload }) {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get(`/t/${tid}/followups`).then(({ data }) => setRows(data)).catch(() => setRows([])), [api, tid]);
  useEffect(() => { load(); }, [load, reload]);
  const replied = async (r) => {
    try { await api.post(`/t/${tid}/followups/${r.lead_id}/replied`); toast.success("Segnato: ha risposto. Sequenza fermata"); } catch (e) { toast.error(errMsg(e)); }
    load();
  };
  if (!rows?.length) return <p className="text-xs text-slate-500" data-testid="followup-list-empty">Nessun contatto nella sequenza.</p>;
  return (
    <ul className="divide-y divide-slate-100 text-xs" data-testid="followup-list">
      {rows.map((r) => (
        <li key={r.lead_id} className="flex flex-wrap items-center justify-between gap-2 py-2" data-testid={`followup-row-${r.lead_id}`}>
          <span className="min-w-0 text-slate-700">{r.name || r.email}{r.is_test ? " · prova" : ""}{r.name && <span className="ml-1 text-slate-400">{r.email}</span>}<span className="block text-slate-500" data-testid={`followup-state-${r.lead_id}`}>
            {r.status === "active" ? `Inviati ${r.sent}/${r.total} · prossimo ${formatDate(r.next_at, true)}` : `Fermato: ${STOP[r.stop_reason] || r.stop_reason} · inviati ${r.sent}/${r.total}`}</span></span>
          {r.status === "active" && canWrite && <Button size="sm" variant="outline" className="h-10" onClick={() => replied(r)} data-testid={`followup-replied-${r.lead_id}`}>Ha risposto</Button>}
        </li>))}
    </ul>);
}
